import FileDownloadIcon from "@mui/icons-material/FileDownloadOutlined";
import { IconButton, Menu, Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { useState } from "react";

import { accessToken } from "../../../contexts/AuthProvider";
import { handleDownload } from "../../../downloads/utils";
import { INK } from "../../../theme/tokens";
import { baseURL } from "../../../utils/networkWrapper";

export const ReportMenu = () => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleDownloadReport = async (filename: string) => {
		try {
			const response = await fetch(`${baseURL}/downloads/sample-report/${filename}`, {
				method: "GET",
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			});

			if (!response.ok) {
				throw new Error(`Failed to download ${filename}`);
			}

			const blob = await response.blob();
			handleDownload(blob, filename);
		} catch (error) {
			console.error(`Error downloading ${filename}:`, error);
		} finally {
			handleClose();
		}
	};

	const handleDownloadBudgetReport = () => handleDownloadReport("Sample-Budget-Report.xlsx");
	const handleDownloadHoursReport = () => handleDownloadReport("Sample-Daily-Hours-Report.xlsx");
	return (
		<div>
			<IconButton
				sx={{ color: INK.SECONDARY }}
				aria-controls={open ? "basic-menu" : undefined}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
				size="small"
			>
				<FileDownloadIcon />
			</IconButton>
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				slotProps={{
					list: {
						sx: { padding: 0 },
						"aria-labelledby": "basic-button",
					},
				}}
			>
				<MenuList>
					<MenuItem onClick={handleDownloadBudgetReport}>
						<Typography
							sx={{
								color: INK.SECONDARY,
								fontWeight: "600",
							}}
						>
							Budget Report
						</Typography>
					</MenuItem>
					<MenuItem onClick={handleDownloadHoursReport}>
						<Typography
							sx={{
								color: INK.SECONDARY,
								fontWeight: "bold",
							}}
						>
							Hours Report
						</Typography>
					</MenuItem>
				</MenuList>
			</Menu>
		</div>
	);
};
